module.exports = __webpack_public_path__ + "media/images/flags/64/Sudan-772dae850bbca2c43c6a0674abe1a063.png";